// import { ServiceProvider } from "./../../providers/service/service";
import { ViewHeaderPage } from "./../view-header/view-header";
import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { Storage } from "@ionic/storage";
import { Component } from "@angular/core";
import { IonicPage, NavController } from "ionic-angular";
// import {
//   StreamingMedia,
//   StreamingVideoOptions,
// } from "@ionic-native/streaming-media";
import { VideoTutorialModalPage } from "../video-tutorial-modal/video-tutorial-modal";

@IonicPage()
@Component({
  selector: "page-manaul-shopper",
  templateUrl: "manaul-shopper.html",
})
export class ManaulShopperPage {
  shopper_no: any;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    private storage: Storage // private services: ServiceProvider,
  ) // private streamingMedia: StreamingMedia
  {
    this.storage.get("info").then((info) => {
      this.shopper_no = info.team.shopper_id;
      // this.shopper_name = info.name;
    });
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");
    // console.log('ionViewDidLoad ManaulShopperPage');
  }

  // createSocialGroup() {
  //   let options: StreamingVideoOptions = {
  //     successCallback: () => {
  //       console.log("Video played");
  //     },
  //     errorCallback: (e) => {
  //       console.log("Error streaming");
  //     },
  //     orientation: "landscape",
  //     shouldAutoClose: true,
  //     controls: true,
  //   };

  //   this.storage.get("video").then((video) => {
  //     this.streamingMedia.playVideo(video[31].video_url, options);
  //   });
  // }

  // joinSocialGroup() {
  //   let options: StreamingVideoOptions = {
  //     successCallback: () => {
  //       console.log("Video played");
  //     },
  //     errorCallback: (e) => {
  //       console.log("Error streaming");
  //     },
  //     orientation: "landscape",
  //     shouldAutoClose: true,
  //     controls: true,
  //   };

  //   this.storage.get("video").then((video) => {
  //     this.streamingMedia.playVideo(video[32].video_url, options);
  //   });
  // }

  // buySocialTicket() {
  //   let options: StreamingVideoOptions = {
  //     successCallback: () => {
  //       console.log("Video played");
  //     },
  //     errorCallback: (e) => {
  //       console.log("Error streaming");
  //     },
  //     orientation: "landscape",
  //     shouldAutoClose: true,
  //     controls: true,
  //   };

  //   this.storage.get("video").then((video) => {
  //     this.streamingMedia.playVideo(video[33].video_url, options);
  //   });
  // }

  // buyProduct() {
  //   let options: StreamingVideoOptions = {
  //     successCallback: () => {
  //       console.log("Video played");
  //     },
  //     errorCallback: (e) => {
  //       console.log("Error streaming");
  //     },
  //     orientation: "landscape",
  //     shouldAutoClose: true,
  //     controls: true,
  //   };

  //   this.storage.get("video").then((video) => {
  //     this.streamingMedia.playVideo(video[34].video_url, options);
  //   });
  // }

  // checkShop() {
  //   let options: StreamingVideoOptions = {
  //     successCallback: () => {
  //       console.log("Video played");
  //     },
  //     errorCallback: (e) => {
  //       console.log("Error streaming");
  //     },
  //     orientation: "landscape",
  //     shouldAutoClose: true,
  //     controls: true,
  //   };

  //   this.storage.get("video").then((video) => {
  //     this.streamingMedia.playVideo(video[35].video_url, options);
  //   });
  // }

  viewVdo(id) {
    this.storage.get("video").then((video) => {
      console.log("video===>", video);
      this.navCtrl.push(VideoTutorialModalPage, {
        id: id,
        vdo: video[id].video_url,
      });
    });
  }

  backPage() {
    this.navCtrl.push(ShopperHomePage);
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.push(ShopperHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/manaul-shopper/manaul-shopper.ts